import { c as n } from "../../../../index.esm-BeDSGXP5.js";
import { css as l } from "styled-components";
const i = {
  base: ({ theme: o }) => /* @__PURE__ */ l([
    "display:flex;justify-content:center;",
    " ",
    ""
  ], o.resets.space, n({
    flexDirection: [
      "column",
      null,
      "row"
    ]
  })),
  default: ({ theme: o }) => /* @__PURE__ */ l([
    "",
    ""
  ], n({
    backgroundColor: o.componentColors.flow.default.background
  })),
  variant1: ({ theme: o }) => /* @__PURE__ */ l([
    "",
    ""
  ], n({
    backgroundColor: o.componentColors.flow.variant1.background
  })),
  variant2: ({ theme: o }) => /* @__PURE__ */ l([
    "",
    ""
  ], n({
    backgroundColor: o.componentColors.flow.variant2.background
  }))
}, t = "4rem", e = {
  base: ({ theme: o }) => /* @__PURE__ */ l([
    "display:flex;flex-direction:column;justify-content:flex-start;align-items:center;position:relative;flex:1;",
    " &::before,&::after{content:'';position:absolute;",
    "}&::before{top:0;left:0;}&::after{z-index:2;",
    "}&:first-of-type::before,&:last-of-type:not(:first-of-type)::after{display:none;}&:first-of-type{",
    "}&:last-of-type{margin-right:0;margin-bottom:0;",
    "}"
  ], n({
    paddingTop: [
      `calc(${o.space.md} + ${t})`,
      null,
      "xl"
    ],
    paddingBottom: [
      0,
      null,
      "lg"
    ],
    marginRight: [
      null,
      null,
      "xs"
    ],
    marginBottom: [
      "xs",
      null,
      "0"
    ],
    paddingRight: [
      "md",
      null,
      0
    ],
    paddingLeft: [
      "md",
      null,
      `calc(${o.space.sm} + ${t})`
    ]
  }), n({
    height: [
      t,
      null,
      "100%"
    ],
    width: [
      "100%",
      null,
      t
    ],
    clipPath: [
      "polygon(0 0, 50% 100%, 100% 0)",
      null,
      "polygon(-1px 0, -1px 100%, 100% 50%);"
    ]
  }), n({
    top: [
      "100%",
      null,
      "0"
    ],
    left: [
      null,
      null,
      "100%"
    ]
  }), n({
    paddingTop: [
      "md",
      null,
      "xl"
    ],
    paddingBottom: [
      0,
      null,
      "xl"
    ],
    paddingRight: [
      "md",
      null,
      0
    ],
    paddingLeft: [
      "md",
      null,
      "md"
    ]
  }), n({
    paddingBottom: [
      "md",
      null,
      "xl"
    ],
    paddingRight: "md"
  })),
  default: ({ theme: o }) => /* @__PURE__ */ l([
    "",
    " &::before{",
    "}&::after{",
    "}"
  ], n({
    backgroundColor: o.componentColors.flowPoint.default.background
  }), n({
    backgroundColor: o.componentColors.flowPoint.default.surface
  }), n({
    backgroundColor: o.componentColors.flowPoint.default.background
  })),
  variant1: ({ theme: o }) => /* @__PURE__ */ l([
    "",
    " &::before{",
    "}&::after{",
    "}"
  ], n({
    backgroundColor: o.componentColors.flowPoint.variant1.background
  }), n({
    backgroundColor: o.componentColors.flowPoint.variant1.surface
  }), n({
    backgroundColor: o.componentColors.flowPoint.variant1.background
  })),
  variant2: ({ theme: o }) => /* @__PURE__ */ l([
    "",
    " &::before{",
    "}&::after{",
    "}"
  ], n({
    backgroundColor: o.componentColors.flowPoint.variant2.background
  }), n({
    backgroundColor: o.componentColors.flowPoint.variant2.surface
  }), n({
    backgroundColor: o.componentColors.flowPoint.variant2.background
  })),
  icon: ({ theme: o }) => /* @__PURE__ */ l([
    "",
    ""
  ], n({
    color: o.componentColors.flow.icon
  }))
};
export {
  i as flow,
  e as flowPoint
};
